import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import ProdutoForm from './ProdutoForm';
import { produtosApi } from '../../api/produtos';
import { COLORS } from '../../theme';

export default function ProdutoList() {
  const [produtos, setProdutos] = useState([]);
  const [busca, setBusca] = useState('');
  const [produtoAbertoId, setProdutoAbertoId] = useState(undefined);

  const carregar = useCallback(() => {
    produtosApi.listar(busca ? { busca } : {}).then(setProdutos).catch(() => {});
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);

  if (produtoAbertoId !== undefined) {
    return (
      <ProdutoForm
        produtoId={produtoAbertoId}
        onVoltar={() => { setProdutoAbertoId(undefined); carregar(); }}
        onSalvo={carregar}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Input placeholder="Buscar por código, descrição ou código do fabricante..." value={busca}
            onChange={e => setBusca(e.target.value)} style={{ width: 360 }} />
          <Btn onClick={() => setProdutoAbertoId(null)}>+ Novo Produto</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Código</th>
              <th style={{ padding: 10 }}>Nome</th>
              <th style={{ padding: 10 }}>Tipo</th>
              <th style={{ padding: 10 }}>NCM</th>
              <th style={{ padding: 10 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {produtos.map(p => (
              <tr key={p.id} onClick={() => setProdutoAbertoId(p.id)}
                style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                <td style={{ padding: 10 }}>{p.codigo}</td>
                <td style={{ padding: 10 }}>{p.nome}</td>
                <td style={{ padding: 10 }}>{p.tipo_produto}</td>
                <td style={{ padding: 10 }}>{p.ncm || '-'}</td>
                <td style={{ padding: 10 }}>
                  {p.suspenso ? <Badge tom="perigo">Suspenso</Badge> : <Badge tom="sucesso">Ativo</Badge>}
                </td>
              </tr>
            ))}
            {produtos.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMuted }}>Nenhum produto cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
